const initHeaderSearch = () => {
	const search = document.querySelector('.site-header .search-form');
	const searchInput = document.querySelector('.site-header .search-field');
	const searchWrap = document.querySelector('.site-header .search-form-wrapper');

	search.onmouseover = () => {
		search.classList.add('active');
		searchWrap.classList.add('active');
		searchInput.focus();
	};

	document.addEventListener('click', (el) => {
		if (!el.target.classList.contains('search-submit') && !el.target.classList.contains('search-field') && !el.target.classList.contains('search-form')) {
			search.classList.remove('active');
			searchWrap.classList.remove('active');
		}
	});
};

document.addEventListener('DOMContentLoaded', initHeaderSearch);
